import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography'
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Button } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import Popover from '@material-ui/core/Popover';
import CircularProgress from '@material-ui/core/CircularProgress';
import Icon from '@material-ui/core/Icon';
import { CheckboxComponent } from '../../components/CheckboxComponent';
import { TextInputComponent } from '../../components/TextInputComponent';
import { ValidationHelper } from '../../helpers/ValidationHelper';

import { AppConfig } from '../../AppConfig';
import { CommonStyles } from '../../styles/Styles';
import {
  AppTheme,
  AppStyles
} from '../../styles/AppTheme';
import { ColourPalette } from '../../styles/AppColourPalette';
import {
  StyleSheet,
  css
} from 'aphrodite';

export class CustomFormFieldsDialog extends Component {

  constructor(props) {
    super(props);
    this.responseByKey = this.props.responseByKey || {}
    this.labelByAction = {
      lookup: 'NEXT',
      delete: 'DELETE',
      add: 'SAVE',
      edit:'SAVE',
      upload: 'UPLOAD'
    }
    this.state = {
    }
  }

  setValue = (value, key) => {
    this.responseByKey[key] = value
  }

  onSubmit = () => {
    this.validateFieldsAndSubmit()
  }

  validateFieldsAndSubmit() {
    console.log('validateFieldsAndSubmit')
    let valid = true
    for (const formField of this.props.formFields) {
      if (ValidationHelper.validateFields(formField, this.responseByKey[formField.key])) {
        valid = false
      }
    }
    if (valid) {
      this.props.onSuccess(this.responseByKey)
    }
  }

  getFormFieldContent = (formField) => {
    if (formField.type === 'input_text') {
      return (
        <TextInputComponent
          formField={formField}
          value={this.responseByKey[formField.key]}
          enableValidation={this.props.enableValidation}
          setValue={this.setValue}
          disabled={this.props.formDisabled}
        />
      )
    } else if (formField.type === 'checkbox') {
      return (
        <CheckboxComponent
          formField={formField}
          value={this.responseByKey[formField.key] ? this.responseByKey[formField.key] : []}
          enableValidation={this.props.enableValidation}
          setValue={this.setValue.bind(this)}
          disabled={this.props.formDisabled}
        />
      )
    }
  }

  generateContent = () => {
    const leftFields = []
    const rightFields = []
    const fullLengthFields = []

    for (const formField of this.props.formFields) {
      if (formField.placement === 'left') {
        leftFields.push(this.getFormFieldContent(formField))
      } else if (formField.placement === 'right') {
        rightFields.push(this.getFormFieldContent(formField))
      } else if (formField.placement === 'full') {
        fullLengthFields.push(this.getFormFieldContent(formField))
      }
    }

    return (
      <div className={css(Styles.fieldsOuterContainer)}>
        <div className={css(Styles.fieldsInnerContainerOne)}>
          <div className={css(Styles.fieldsOuterContainer)}>
            {leftFields}
          </div>
          <div className={css(Styles.fieldsOuterContainer)}>
            {rightFields}
          </div>
        </div>
        <div className={css(Styles.fieldsOuterContainer)}>
          {fullLengthFields}
        </div>
      </div>
    )
  }
  render() {
    this.responseByKey = this.props.responseByKey || {}
    return (
      <Dialog
        onClose={this.props.onClose}
        open={this.props.dialogOpen}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <div className={css(Styles.dialogTitleContainer)}>
            <p className={css(Styles.dialogTitleContent)}>{this.props.dialogTitle}</p>
            <div className={css(Styles.closeIconContainer)} onClick={this.props.onClose}>
              <img src={require('../../assets/images/close-img.svg')} className={css(Styles.closeIcon)} />
            </div>
          </div>
        </DialogTitle>
        <DialogContent className={css(Styles.dialogContent)}>
          <div className={css(Styles.fieldsContainer)}>
            {this.props.confirmDeleteView &&
              <div>
                <p className={css(Styles.deleteConfirmMsg)}>Are you sure you want to delete member {this.props.selectedItem.email}?</p>
                <p className={css(Styles.deleteConfirmMsg)}>This action cannot be undone.</p>
              </div>
            }
            {!this.props.confirmDeleteView &&
              <div className={css(Styles.fieldsInnerContainer)}>
                {this.props.formFields &&
                  this.generateContent()
                }
              </div>
            }
          </div>
        </DialogContent>
        <DialogActions className={css(Styles.dialogActions)}>
          <div className={css(Styles.dialogActionsInnerContainer)}>
            {this.props.errMsg &&
              <p className={css(Styles.deleteMsg)}>{this.props.errMsg}</p>
            }
            <div className={css(Styles.dialogActionsInnerContainerButton)}>
              {this.props.confirmDeleteView &&
                <Button
                  disabled={this.props.inProcess}
                  variant='contained'
                  onClick={e => this.props.deleteItem()}
                  className={css(Styles.buttonStyle)}>
                  DELETE
                  {this.props.inProcess && <CircularProgress color='primary' size={20} className={css(Styles.circulerProgress)} />}
                </Button>
              }
              {!this.props.confirmDeleteView && this.props.action &&
                <Button
                  disabled={this.props.inProcess}
                  variant='contained'
                  onClick={this.props.action === 'delete' ?
                    e => this.props.showConfirmDeleteView() :
                    e => this.onSubmit()}
                  className={css(Styles.buttonStyle)}>
                  {this.labelByAction[this.props.action]}
                  {this.state.inProcess && <CircularProgress color='primary' size={20} className={css(Styles.circulerProgress)} />}
                </Button>
              }
            </div>
          </div>
        </DialogActions>
      </Dialog>
    )
  }
}

const Styles = StyleSheet.create({
  dialog: {
    minWidth: 850,
    '@media(max-width: 768px)': {
      minWidth: '-webkit-fill-available',
      margin: 5
    }
  },
  scrollPaper: {
    justifyContent: 'center',
    '@media(max-width: 767px)': {
      overflow: 'scroll',
      justifyContent: 'flex-start'
    }
  },
  dialogTitle: {
    backgroundColor: AppTheme.white,
    padding: 20,
  },
  dialogTitleContainer: {
    display: 'flex'
  },
  dialogTitleContent: {
    margin: 0,
    fontSize: AppTheme.fontSizeTitle,
    cursor: 'default'
  },
  closeIconContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    cursor: 'pointer'
  },
  dialogContent: {
    backgroundColor: AppTheme.primaryBackground,
    display: 'flex',
    justifyContent: 'center',
  },
  fieldsContainer: {
    width: '80%'
  },
  fieldsInnerContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  dialogActions: {
    backgroundColor: AppTheme.primaryBackground,
    display: 'flex',
    justifyContent: 'center',
    padding: 24,
    paddingTop: 0
  },
  dialogActionsInnerContainer: {
    width: '80%',
    display: 'flex',
  },
  dialogActionsInnerContainerButton: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  deleteMsg: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    fontWeight: 'bold',
    color: AppTheme.white,
    fontSize: 15,
    cursor: 'defalut',
    marginLeft: 8
  },
  buttonStyle: {
    marginRight: 8,
    backgroundColor: ColourPalette.color3,
    borderRadius: 4,
    color: AppTheme.white,
    fontWeight: 'bold',
    fontSize: 11,
    padding: '5px 16px'
  },
  circulerProgress: {
    marginLeft: 10,
    color: AppTheme.white
  },
  deleteConfirmMsg: {
    color: AppTheme.white,
    cursor: 'default'
  },
  fieldsOuterContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
  },
  fieldsInnerContainerOne: {
    display: 'flex'
  }
})


// WEBPACK FOOTER //
// ./src/screens/GuestUsersDetails/CustomFormFieldsDialog.js